import { isAxiosError } from 'axios';
import { JBErrorDto } from '@bjb-gcrm/gcrm-frontend-components';

// Problem type the backend sends with a 403 while the access service (PCA) does not know a BR its creator just created
const BR_ACCESS_PENDING_PROBLEM_TYPE = 'br-access-pending';
const MAX_ACCESS_PENDING_RETRIES = 5;
const ACCESS_PENDING_RETRY_DELAY_MS = 3_000;
const MAX_RETRIES = 3;
const MAX_RETRY_DELAY_MS = 5_000;

const isAccessPending = (error: unknown) =>
  isAxiosError<JBErrorDto>(error) &&
  error.response?.status === 403 &&
  error.response.data?.type === BR_ACCESS_PENDING_PROBLEM_TYPE;

const isClientError = (error: unknown) => {
  const status = isAxiosError(error) ? error.response?.status : undefined;
  return status !== undefined && status >= 400 && status < 500;
};

/**
 * Retry policy for queries that fetch a BR: a pending access to a just created BR is retried up to five times, three
 * seconds apart (about 15 seconds of waiting, 20 including the requests) to give PCA time to learn about the BR, any
 * other client error is not retried, and server or network errors are retried up to three times.
 */
export const brQueryRetry = (failureCount: number, error: unknown) => {
  if (isAccessPending(error)) {
    return failureCount < MAX_ACCESS_PENDING_RETRIES;
  }
  if (isClientError(error)) {
    return false;
  }
  return failureCount < MAX_RETRIES;
};

export const brQueryRetryDelay = (failureCount: number, error: unknown) =>
  isAccessPending(error) ? ACCESS_PENDING_RETRY_DELAY_MS : Math.min(1_000 * 2 ** failureCount, MAX_RETRY_DELAY_MS);
